/**
 * @description image width 30%
 * @author wangfupeng
 */

import ImageWidthBaseClass from './WidthBase'

class ImageWidth30 extends ImageWidthBaseClass {
  readonly title = '30%' // 菜单标题

  readonly value = '30%' // css width 的值
}

export default ImageWidth30
